import {forkJoin as observableForkJoin, Observable} from 'rxjs';
import {User} from './currentuser/user';
import {DEFAULT_TIME_ZONE, TimeZoneConfiguration} from './uiconfiguration/timezoneconfiguration';
import {UIConfiguration} from './uiconfiguration/uiconfiguration';
import {CacheService} from './cache.service';

export class TimeZoneHandling {
  public static createTimeZoneObservable(cacheService: CacheService): Observable<string> {
    // TIMEZONE
    // 1. current user
    // 2. ui config
    // 3. UTC
    return observableForkJoin(
      cacheService.getCurrentUser(),
      cacheService.getTimeZoneConfigurations(),
      cacheService.getUIConfiguration(),
      (user: User, tzConfigs: TimeZoneConfiguration[], uiConfig: UIConfiguration) => {
        let tzName: string = undefined;
        const tzConfigIds = tzConfigs.map(x => x.id);

        let index = tzConfigIds.indexOf(user.timezone);
        if (index !== -1) {
          tzName = TimeZoneHandling.msZoneLookup[tzConfigs[index].timezoneid];
        }

        if (tzName === undefined) {
          index = tzConfigIds.indexOf(uiConfig.timezone);
          if (index !== -1) {
            tzName = TimeZoneHandling.msZoneLookup[tzConfigs[index].timezoneid];
          }
        }

        if (tzName === undefined) {
          tzName = DEFAULT_TIME_ZONE;
        }

        return tzName;
      },
    );
  }

  private static msZoneLookup = {
    'Greenwich Standard Time': 'Atlantic/Reykjavik',
    'GMT Standard Time': 'Europe/London',
    'W. Europe Standard Time': 'Europe/Berlin',
    'Central Europe Standard Time': 'Europe/Budapest',
    'Romance Standard Time': 'Europe/Paris',
    'Central European Standard Time': 'Europe/Warsaw',
    'W. Central Africa Standard Time': 'Africa/Lagos',
    'Jordan Standard Time': 'Asia/Amman',
    'GTB Standard Time': 'Europe/Bucharest',
    'Middle East Standard Time': 'Asia/Beirut',
    'Egypt Standard Time': 'Africa/Cairo',
    'South Africa Standard Time': 'Africa/Johannesburg',
    'FLE Standard Time': 'Europe/Kiev',
    'Israel Standard Time': 'Asia/Jerusalem',
    'E. Europe Standard Time': 'Europe/Chisinau',
    'Namibia Standard Time': 'Africa/Windhoek',
    'Arabic Standard Time': 'Asia/Baghdad',
    'Arab Standard Time': 'Asia/Riyadh',
    'Russian Standard Time': 'Europe/Moscow',
    'E. Africa Standard Time': 'Africa/Nairobi',
    'Georgian Standard Time': 'Asia/Tbilisi',
    'Iran Standard Time': 'Asia/Tehran',
    'Arabian Standard Time': 'Asia/Dubai',
    'Azerbaijan Standard Time': 'Asia/Baku',
    'Caucasus Standard Time': 'Asia/Yerevan',
    'Afghanistan Standard Time': 'Asia/Kabul',
    'Ekaterinburg Standard Time': 'Asia/Yekaterinburg',
    'West Asia Standard Time': 'Asia/Tashkent',
    'India Standard Time': 'Asia/Calcutta',
    'Sri Lanka Standard Time': 'Asia/Colombo',
    'Nepal Standard Time': 'Asia/Katmandu',
    'Central Asia Standard Time': 'Asia/Almaty',
    'N. Central Asia Standard Time': 'Asia/Novosibirsk',
    'Myanmar Standard Time': 'Asia/Rangoon',
    'SE Asia Standard Time': 'Asia/Bangkok',
    'North Asia Standard Time': 'Asia/Krasnoyarsk',
    'China Standard Time': 'Asia/Shanghai',
    'North Asia East Standard Time': 'Asia/Irkutsk',
    'Singapore Standard Time': 'Asia/Singapore',
    'W. Australia Standard Time': 'Australia/Perth',
    'Taipei Standard Time': 'Asia/Taipei',
    'Tokyo Standard Time': 'Asia/Tokyo',
    'Korea Standard Time': 'Asia/Seoul',
    'Yakutsk Standard Time': 'Asia/Yakutsk',
    'Cen. Australia Standard Time': 'Australia/Adelaide',
    'AUS Central Standard Time': 'Australia/Darwin',
    'E. Australia Standard Time': 'Australia/Brisbane',
    'AUS Eastern Standard Time': 'Australia/Sydney',
    'West Pacific Standard Time': 'Pacific/Port_Moresby',
    'Tasmania Standard Time': 'Australia/Hobart',
    'Vladivostok Standard Time': 'Asia/Vladivostok',
    'Central Pacific Standard Time': 'Pacific/Guadalcanal',
    'New Zealand Standard Time': 'Pacific/Auckland',
    'Fiji Standard Time': 'Pacific/Fiji',
    'Tonga Standard Time': 'Pacific/Tongatapu',
    'Azores Standard Time': 'Atlantic/Azores',
    'Cape Verde Standard Time': 'Atlantic/Cape_Verde',
    'Mid-Atlantic Standard Time': 'Atlantic/South_Georgia',
    'E. South America Standard Time': 'America/Sao_Paulo',
    'SA Eastern Standard Time': 'America/Cayenne',
    'Greenland Standard Time': 'America/Godthab',
    'Montevideo Standard Time': 'America/Montevideo',
    'Newfoundland Standard Time': 'America/St_Johns',
    'Atlantic Standard Time': 'America/Halifax',
    'SA Western Standard Time': 'America/La_Paz',
    'Central Brazilian Standard Time': 'America/Cuiaba',
    'Pacific SA Standard Time': 'America/Santiago',
    'Venezuela Standard Time': 'America/Caracas',
    'SA Pacific Standard Time': 'America/Bogota',
    'Eastern Standard Time': 'America/New_York',
    'US Eastern Standard Time': 'America/Indianapolis',
    'Central America Standard Time': 'America/Guatemala',
    'Central Standard Time': 'America/Chicago',
    'Central Standard Time (Mexico)': 'America/Mexico_City',
    'Canada Central Standard Time': 'America/Regina',
    'US Mountain Standard Time': 'America/Phoenix',
    'Mountain Standard Time (Mexico)': 'America/Chihuahua',
    'Mountain Standard Time': 'America/Denver',
    'Pacific Standard Time': 'America/Los_Angeles',
    'Pacific Standard Time (Mexico)': 'America/Tijuana',
    'Alaskan Standard Time': 'America/Anchorage',
    'Hawaiian Standard Time': 'Pacific/Honolulu',
    'Samoa Standard Time': 'Pacific/Apia',
    'Dateline Standard Time': 'Etc/GMT+12',
  };
}
